<div class="shared-mapping-list adminListScroll" [ngClass]="{'full-height':!hasLegends}">
    <mat-list>
        <mat-list-item *ngFor="let mapping of mappings" [value]="mapping.id" (click)="onSelection(mapping)"
        [ngClass]="{'active': getIsActive(mapping) }">
            <ng-container [ngTemplateOutlet]="mappingDetailTemplate" [ngTemplateOutletContext]="{ $implicit: mapping }"></ng-container>
            <ng-container *ngIf="isDefaultMappingStatus">
                <mat-list>
                    <mat-list-item>
                        <div *ngIf="!mapping.isMapped">
                            <span class="icon-notification"></span> Unmapped
                        </div>
                    </mat-list-item>
                </mat-list>
            </ng-container>

            <mat-list>
                <mat-list>
                    <div *ngIf="mapping.isNew">
                        <span class="icon-plus"></span> New
                    </div>
                </mat-list>
            </mat-list>
        </mat-list-item>
    </mat-list>
</div>
